module.exports = __webpack_public_path__ + "img/banner3.454dd80d.jpg";